module.exports = __webpack_public_path__ + "img/logo.9f5dbd6e.svg";